export default __webpack_public_path__ + "static/media/hht2_ep01_timeline_q02_b.255b84dc.png";